import * as React from 'react';

function SvgConfirmation(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h24v24H0z" />
      <path d="M3.5 7h2V4.5H19V7h1.5v14h-17V7z" fill="#FCCE01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.85A1.15 1.15 0 005.85 4v7.727l4.829 3.761a2.15 2.15 0 002.642 0l4.829-3.76V4A1.15 1.15 0 0017 2.85h-1a.85.85 0 010-1.7h1A2.85 2.85 0 0119.85 4v1.029l3.72 3.368a.85.85 0 01.28.63V20A3.85 3.85 0 0120 23.85H4A3.85 3.85 0 01.15 20V9.027a.85.85 0 01.285-.635L4.15 5.09V4A2.85 2.85 0 017 1.15h5a.85.85 0 010 1.7H7zM2.328 8.984l1.822-1.62v3.04l-1.822-1.42zm19.351-.006l-1.83 1.425v-3.08l1.83 1.655zm.47 1.789l-7.783 6.062a3.85 3.85 0 01-4.732 0L1.85 10.766V20c0 .284.055.555.155.803L5.94 17.36a.85.85 0 011.12 1.28l-3.844 3.363c.243.095.507.147.784.147h16c.276 0 .54-.052.784-.147L16.94 18.64a.85.85 0 011.12-1.28l3.935 3.444c.1-.249.155-.52.155-.804v-9.233zm-6.546-4.168a.85.85 0 00-1.206-1.198l-3.405 3.427-1.424-1.279a.85.85 0 00-1.136 1.265l2.025 1.819a.85.85 0 001.17-.034l3.976-4z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgConfirmation;
